"use strict";

require("../../style/index.less");

require("./index.less");

require("../../grid/style");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/form/style/index.js
// module id = 20
// module chunks = 1